/**
 * Global Countries & Cities Database
 * 
 * Complete ISO 3166-1 country codes with native names, flags, and major cities.
 * Used for global location autocomplete with free-text search.
 */

// All ISO 3166-1 alpha-2 countries sorted by population/relevance
export const ALL_COUNTRIES = [
  // Priority countries (Nordic + Baltic + Common)
  { code: 'EE', name: 'Estonia', nativeName: 'Eesti', flag: '🇪🇪', region: 'europe' },
  { code: 'FI', name: 'Finland', nativeName: 'Suomi', flag: '🇫🇮', region: 'europe' },
  { code: 'SE', name: 'Sweden', nativeName: 'Sverige', flag: '🇸🇪', region: 'europe' },
  { code: 'NO', name: 'Norway', nativeName: 'Norge', flag: '🇳🇴', region: 'europe' },
  { code: 'DK', name: 'Denmark', nativeName: 'Danmark', flag: '🇩🇰', region: 'europe' },
  { code: 'IS', name: 'Iceland', nativeName: 'Ísland', flag: '🇮🇸', region: 'europe' },
  { code: 'LV', name: 'Latvia', nativeName: 'Latvija', flag: '🇱🇻', region: 'europe' },
  { code: 'LT', name: 'Lithuania', nativeName: 'Lietuva', flag: '🇱🇹', region: 'europe' },
  
  // Western Europe
  { code: 'DE', name: 'Germany', nativeName: 'Deutschland', flag: '🇩🇪', region: 'europe' },
  { code: 'GB', name: 'United Kingdom', nativeName: 'United Kingdom', flag: '🇬🇧', region: 'europe' },
  { code: 'FR', name: 'France', nativeName: 'France', flag: '🇫🇷', region: 'europe' },
  { code: 'NL', name: 'Netherlands', nativeName: 'Nederland', flag: '🇳🇱', region: 'europe' },
  { code: 'BE', name: 'Belgium', nativeName: 'België', flag: '🇧🇪', region: 'europe' },
  { code: 'AT', name: 'Austria', nativeName: 'Österreich', flag: '🇦🇹', region: 'europe' },
  { code: 'CH', name: 'Switzerland', nativeName: 'Schweiz', flag: '🇨🇭', region: 'europe' },
  { code: 'IE', name: 'Ireland', nativeName: 'Éire', flag: '🇮🇪', region: 'europe' },
  { code: 'LU', name: 'Luxembourg', nativeName: 'Lëtzebuerg', flag: '🇱🇺', region: 'europe' },
  
  // Southern Europe
  { code: 'ES', name: 'Spain', nativeName: 'España', flag: '🇪🇸', region: 'europe' },
  { code: 'IT', name: 'Italy', nativeName: 'Italia', flag: '🇮🇹', region: 'europe' },
  { code: 'PT', name: 'Portugal', nativeName: 'Portugal', flag: '🇵🇹', region: 'europe' },
  { code: 'GR', name: 'Greece', nativeName: 'Ελλάδα', flag: '🇬🇷', region: 'europe' },
  { code: 'MT', name: 'Malta', nativeName: 'Malta', flag: '🇲🇹', region: 'europe' },
  { code: 'CY', name: 'Cyprus', nativeName: 'Κύπρος', flag: '🇨🇾', region: 'europe' },
  
  // Central Europe
  { code: 'PL', name: 'Poland', nativeName: 'Polska', flag: '🇵🇱', region: 'europe' },
  { code: 'CZ', name: 'Czech Republic', nativeName: 'Česko', flag: '🇨🇿', region: 'europe' },
  { code: 'SK', name: 'Slovakia', nativeName: 'Slovensko', flag: '🇸🇰', region: 'europe' },
  { code: 'HU', name: 'Hungary', nativeName: 'Magyarország', flag: '🇭🇺', region: 'europe' },
  { code: 'SI', name: 'Slovenia', nativeName: 'Slovenija', flag: '🇸🇮', region: 'europe' },
  { code: 'HR', name: 'Croatia', nativeName: 'Hrvatska', flag: '🇭🇷', region: 'europe' },
  
  // Eastern Europe
  { code: 'UA', name: 'Ukraine', nativeName: 'Україна', flag: '🇺🇦', region: 'europe' },
  { code: 'RO', name: 'Romania', nativeName: 'România', flag: '🇷🇴', region: 'europe' },
  { code: 'BG', name: 'Bulgaria', nativeName: 'България', flag: '🇧🇬', region: 'europe' },
  { code: 'RU', name: 'Russia', nativeName: 'Россия', flag: '🇷🇺', region: 'europe' },
  { code: 'BY', name: 'Belarus', nativeName: 'Беларусь', flag: '🇧🇾', region: 'europe' },
  { code: 'MD', name: 'Moldova', nativeName: 'Moldova', flag: '🇲🇩', region: 'europe' },
  
  // Balkans
  { code: 'RS', name: 'Serbia', nativeName: 'Србија', flag: '🇷🇸', region: 'europe' },
  { code: 'BA', name: 'Bosnia and Herzegovina', nativeName: 'Bosna i Hercegovina', flag: '🇧🇦', region: 'europe' },
  { code: 'AL', name: 'Albania', nativeName: 'Shqipëri', flag: '🇦🇱', region: 'europe' },
  { code: 'MK', name: 'North Macedonia', nativeName: 'Северна Македонија', flag: '🇲🇰', region: 'europe' },
  { code: 'ME', name: 'Montenegro', nativeName: 'Crna Gora', flag: '🇲🇪', region: 'europe' },
  { code: 'XK', name: 'Kosovo', nativeName: 'Kosovë', flag: '🇽🇰', region: 'europe' },
  
  // North America
  { code: 'US', name: 'United States', nativeName: 'United States', flag: '🇺🇸', region: 'americas' },
  { code: 'CA', name: 'Canada', nativeName: 'Canada', flag: '🇨🇦', region: 'americas' },
  { code: 'MX', name: 'Mexico', nativeName: 'México', flag: '🇲🇽', region: 'americas' },
  
  // South America
  { code: 'BR', name: 'Brazil', nativeName: 'Brasil', flag: '🇧🇷', region: 'americas' },
  { code: 'AR', name: 'Argentina', nativeName: 'Argentina', flag: '🇦🇷', region: 'americas' },
  { code: 'CL', name: 'Chile', nativeName: 'Chile', flag: '🇨🇱', region: 'americas' },
  { code: 'CO', name: 'Colombia', nativeName: 'Colombia', flag: '🇨🇴', region: 'americas' },
  { code: 'PE', name: 'Peru', nativeName: 'Perú', flag: '🇵🇪', region: 'americas' },
  
  // Asia Pacific
  { code: 'CN', name: 'China', nativeName: '中国', flag: '🇨🇳', region: 'asia' },
  { code: 'JP', name: 'Japan', nativeName: '日本', flag: '🇯🇵', region: 'asia' },
  { code: 'KR', name: 'South Korea', nativeName: '한국', flag: '🇰🇷', region: 'asia' },
  { code: 'IN', name: 'India', nativeName: 'भारत', flag: '🇮🇳', region: 'asia' },
  { code: 'AU', name: 'Australia', nativeName: 'Australia', flag: '🇦🇺', region: 'oceania' },
  { code: 'NZ', name: 'New Zealand', nativeName: 'New Zealand', flag: '🇳🇿', region: 'oceania' },
  { code: 'SG', name: 'Singapore', nativeName: 'Singapore', flag: '🇸🇬', region: 'asia' },
  { code: 'TH', name: 'Thailand', nativeName: 'ประเทศไทย', flag: '🇹🇭', region: 'asia' },
  { code: 'VN', name: 'Vietnam', nativeName: 'Việt Nam', flag: '🇻🇳', region: 'asia' },
  { code: 'PH', name: 'Philippines', nativeName: 'Pilipinas', flag: '🇵🇭', region: 'asia' },
  { code: 'MY', name: 'Malaysia', nativeName: 'Malaysia', flag: '🇲🇾', region: 'asia' },
  { code: 'ID', name: 'Indonesia', nativeName: 'Indonesia', flag: '🇮🇩', region: 'asia' },
  
  // Middle East
  { code: 'AE', name: 'United Arab Emirates', nativeName: 'الإمارات', flag: '🇦🇪', region: 'middle-east', rtl: true },
  { code: 'SA', name: 'Saudi Arabia', nativeName: 'السعودية', flag: '🇸🇦', region: 'middle-east', rtl: true },
  { code: 'IL', name: 'Israel', nativeName: 'ישראל', flag: '🇮🇱', region: 'middle-east', rtl: true },
  { code: 'TR', name: 'Turkey', nativeName: 'Türkiye', flag: '🇹🇷', region: 'middle-east' },
  { code: 'EG', name: 'Egypt', nativeName: 'مصر', flag: '🇪🇬', region: 'africa', rtl: true },
  
  // Africa
  { code: 'ZA', name: 'South Africa', nativeName: 'South Africa', flag: '🇿🇦', region: 'africa' },
  { code: 'NG', name: 'Nigeria', nativeName: 'Nigeria', flag: '🇳🇬', region: 'africa' },
  { code: 'KE', name: 'Kenya', nativeName: 'Kenya', flag: '🇰🇪', region: 'africa' },
  { code: 'MA', name: 'Morocco', nativeName: 'المغرب', flag: '🇲🇦', region: 'africa', rtl: true },
  
  // Special options
  { code: 'REMOTE', name: 'Remote / Worldwide', nativeName: 'Remote', flag: '🌐', region: 'special' },
];

// Major cities by country code
export const CITIES_BY_COUNTRY = {
  // Nordic & Baltic
  EE: ['Tallinn', 'Tartu', 'Narva', 'Pärnu', 'Kohtla-Järve', 'Viljandi', 'Rakvere', 'Maardu', 'Sillamäe', 'Kuressaare'],
  FI: ['Helsinki', 'Espoo', 'Tampere', 'Vantaa', 'Oulu', 'Turku', 'Jyväskylä', 'Lahti', 'Kuopio', 'Kouvola', 'Pori', 'Joensuu'],
  SE: ['Stockholm', 'Göteborg', 'Malmö', 'Uppsala', 'Västerås', 'Örebro', 'Linköping', 'Helsingborg', 'Jönköping', 'Norrköping'],
  NO: ['Oslo', 'Bergen', 'Trondheim', 'Stavanger', 'Drammen', 'Fredrikstad', 'Kristiansand', 'Sandnes', 'Tromsø', 'Sarpsborg'],
  DK: ['København', 'Aarhus', 'Odense', 'Aalborg', 'Esbjerg', 'Randers', 'Kolding', 'Horsens', 'Vejle', 'Roskilde'],
  IS: ['Reykjavík', 'Kópavogur', 'Hafnarfjörður', 'Akureyri', 'Reykjanesbær'],
  LV: ['Rīga', 'Daugavpils', 'Liepāja', 'Jelgava', 'Jūrmala', 'Ventspils', 'Rēzekne'],
  LT: ['Vilnius', 'Kaunas', 'Klaipėda', 'Šiauliai', 'Panevėžys', 'Alytus'],
  
  // Western Europe
  DE: ['Berlin', 'Hamburg', 'München', 'Köln', 'Frankfurt', 'Stuttgart', 'Düsseldorf', 'Leipzig', 'Dortmund', 'Essen', 'Bremen', 'Dresden', 'Hannover', 'Nürnberg'],
  GB: ['London', 'Birmingham', 'Manchester', 'Glasgow', 'Liverpool', 'Leeds', 'Sheffield', 'Edinburgh', 'Bristol', 'Leicester', 'Cardiff', 'Belfast', 'Newcastle'],
  FR: ['Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice', 'Nantes', 'Montpellier', 'Strasbourg', 'Bordeaux', 'Lille', 'Rennes'],
  NL: ['Amsterdam', 'Rotterdam', 'Den Haag', 'Utrecht', 'Eindhoven', 'Tilburg', 'Groningen', 'Almere', 'Breda', 'Nijmegen'],
  BE: ['Brussel', 'Antwerpen', 'Gent', 'Charleroi', 'Liège', 'Brugge', 'Namur', 'Leuven'],
  AT: ['Wien', 'Graz', 'Linz', 'Salzburg', 'Innsbruck', 'Klagenfurt'],
  CH: ['Zürich', 'Genève', 'Basel', 'Lausanne', 'Bern', 'Winterthur', 'Luzern', 'St. Gallen'],
  IE: ['Dublin', 'Cork', 'Limerick', 'Galway', 'Waterford'],
  
  // Southern Europe
  ES: ['Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Zaragoza', 'Málaga', 'Murcia', 'Palma', 'Bilbao', 'Alicante'],
  IT: ['Roma', 'Milano', 'Napoli', 'Torino', 'Palermo', 'Genova', 'Bologna', 'Firenze', 'Bari', 'Catania', 'Venezia'],
  PT: ['Lisboa', 'Porto', 'Amadora', 'Braga', 'Setúbal', 'Coimbra', 'Funchal'],
  GR: ['Αθήνα', 'Θεσσαλονίκη', 'Πάτρα', 'Ηράκλειο', 'Λάρισα', 'Βόλος'],
  
  // Central Europe
  PL: ['Warszawa', 'Kraków', 'Łódź', 'Wrocław', 'Poznań', 'Gdańsk', 'Szczecin', 'Bydgoszcz', 'Lublin', 'Białystok'],
  CZ: ['Praha', 'Brno', 'Ostrava', 'Plzeň', 'Liberec', 'Olomouc'],
  SK: ['Bratislava', 'Košice', 'Prešov', 'Žilina', 'Nitra', 'Banská Bystrica'],
  HU: ['Budapest', 'Debrecen', 'Szeged', 'Miskolc', 'Pécs', 'Győr'],
  
  // Eastern Europe
  UA: ['Kyiv', 'Kharkiv', 'Odesa', 'Dnipro', 'Donetsk', 'Zaporizhzhia', 'Lviv'],
  RO: ['București', 'Cluj-Napoca', 'Timișoara', 'Iași', 'Constanța', 'Craiova'],
  BG: ['София', 'Пловдив', 'Варна', 'Бургас', 'Русе'],
  RU: ['Москва', 'Санкт-Петербург', 'Новосибирск', 'Екатеринбург', 'Казань', 'Нижний Новгород'],
  
  // Americas
  US: ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Philadelphia', 'San Antonio', 'San Diego', 'Dallas', 'San Jose', 'Austin', 'Seattle', 'Denver', 'Boston', 'Miami', 'San Francisco'],
  CA: ['Toronto', 'Montreal', 'Vancouver', 'Calgary', 'Edmonton', 'Ottawa', 'Winnipeg', 'Quebec City'],
  MX: ['Ciudad de México', 'Guadalajara', 'Monterrey', 'Puebla', 'Tijuana', 'León', 'Cancún'],
  BR: ['São Paulo', 'Rio de Janeiro', 'Brasília', 'Salvador', 'Fortaleza', 'Belo Horizonte', 'Manaus', 'Curitiba'],
  AR: ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata'],
  
  // Asia Pacific
  CN: ['Shanghai', 'Beijing', 'Shenzhen', 'Guangzhou', 'Chengdu', 'Hangzhou', 'Wuhan', 'Xian', 'Nanjing'],
  JP: ['Tokyo', 'Osaka', 'Nagoya', 'Sapporo', 'Fukuoka', 'Kobe', 'Kyoto', 'Yokohama', 'Kawasaki'],
  KR: ['Seoul', 'Busan', 'Incheon', 'Daegu', 'Daejeon', 'Gwangju'],
  IN: ['Mumbai', 'Delhi', 'Bangalore', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad'],
  AU: ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide', 'Gold Coast', 'Canberra'],
  NZ: ['Auckland', 'Wellington', 'Christchurch', 'Hamilton', 'Dunedin'],
  SG: ['Singapore'],
  TH: ['Bangkok', 'Nonthaburi', 'Nakhon Ratchasima', 'Chiang Mai', 'Pattaya', 'Phuket'],
  VN: ['Ho Chi Minh City', 'Hanoi', 'Hai Phong', 'Da Nang', 'Can Tho'],
  PH: ['Manila', 'Quezon City', 'Davao City', 'Cebu City', 'Caloocan'],
  MY: ['Kuala Lumpur', 'George Town', 'Johor Bahru', 'Ipoh', 'Shah Alam'],
  ID: ['Jakarta', 'Surabaya', 'Bandung', 'Medan', 'Semarang', 'Bali'],
  
  // Middle East
  AE: ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Ras Al Khaimah'],
  SA: ['Riyadh', 'Jeddah', 'Mecca', 'Medina', 'Dammam'],
  IL: ['Tel Aviv', 'Jerusalem', 'Haifa', 'Rishon LeZion', 'Petah Tikva'],
  TR: ['Istanbul', 'Ankara', 'Izmir', 'Bursa', 'Antalya', 'Adana', 'Konya'],
  EG: ['Cairo', 'Alexandria', 'Giza', 'Sharm El Sheikh', 'Hurghada'],
  
  // Africa
  ZA: ['Johannesburg', 'Cape Town', 'Durban', 'Pretoria', 'Port Elizabeth'],
  NG: ['Lagos', 'Kano', 'Ibadan', 'Abuja', 'Port Harcourt'],
  KE: ['Nairobi', 'Mombasa', 'Kisumu', 'Nakuru'],
  MA: ['Casablanca', 'Rabat', 'Fes', 'Marrakech', 'Tangier'],
  
  // Remote option
  REMOTE: ['Anywhere', 'Worldwide', 'Global'],
};

/**
 * Get country by code
 */
export const getCountryByCode = (code) => {
  if (!code) return null;
  const upperCode = code.toUpperCase();
  return ALL_COUNTRIES.find(c => c.code === upperCode);
};

/**
 * Get cities for a country
 */
export const getCitiesForCountry = (countryCode) => {
  if (!countryCode) return [];
  const upperCode = countryCode.toUpperCase();
  return CITIES_BY_COUNTRY[upperCode] || [];
};

/**
 * Search countries by name (English, native, or code)
 */
export const searchCountries = (query, limit = 20) => {
  if (!query || !query.trim()) return ALL_COUNTRIES.slice(0, limit);
  
  const q = query.toLowerCase().trim();
  return ALL_COUNTRIES.filter(country =>
    country.code.toLowerCase().includes(q) ||
    country.name.toLowerCase().includes(q) ||
    country.nativeName.toLowerCase().includes(q)
  ).slice(0, limit);
};

/**
 * Search cities globally or within a country
 */
export const searchCities = (query, countryCode = null, limit = 20) => {
  const cities = countryCode 
    ? getCitiesForCountry(countryCode)
    : Object.values(CITIES_BY_COUNTRY).flat();
  
  if (!query || !query.trim()) return cities.slice(0, limit);
  
  const q = query.toLowerCase().trim();
  return cities.filter(city => 
    city.toLowerCase().includes(q)
  ).slice(0, limit);
};

/**
 * Get all regions for filtering
 */
export const REGIONS = [
  { code: 'europe', name: 'Europe' },
  { code: 'americas', name: 'Americas' },
  { code: 'asia', name: 'Asia' },
  { code: 'oceania', name: 'Oceania' },
  { code: 'africa', name: 'Africa' },
  { code: 'middle-east', name: 'Middle East' },
  { code: 'special', name: 'Special' },
];

/**
 * Get countries by region
 */
export const getCountriesByRegion = (regionCode) => {
  return ALL_COUNTRIES.filter(c => c.region === regionCode);
};

export default {
  ALL_COUNTRIES,
  CITIES_BY_COUNTRY,
  REGIONS,
  getCountryByCode,
  getCitiesForCountry,
  searchCountries,
  searchCities,
  getCountriesByRegion,
};
